import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

// List of possible roles (example: change to match your system)
type UserRole =
  | "SuperAdministrateur"
  | "Administrateur"
  | "Comptable"
  | "Enseignant";
// | "Secretariat"

// Props for ProtectedRoute
interface ProtectedComponentProps {
  allowedRoles?: UserRole[]; // Optional array of roles
  children: ReactNode;
}

// Protected component to restrict access based on user roles
export default function HasRole({
  allowedRoles,
  children,
}: ProtectedComponentProps) {
  const auth = localStorage.getItem("user");

  if (!auth) return <Navigate to="/login" replace />;
  const user = JSON.parse(auth);

  switch (user.role_id) {
    case 1:
      user.role = "Administrateur";
      break;
    case 2:
      user.role = "Comptable";
      break;
    case 3:
      user.role = "Enseignant";
      break;
    default:
      break;
  }

  //1 if role not allowed, return null
  if (!user || !allowedRoles?.includes(user.role as UserRole)) return null;

  // 2 display children if role allowed
  return <>{children}</>;
}
